import { ApiError } from "./apiError"

// openapi-fetch resolves to { data, error, response }. Throw ApiError on any non-2xx,
// otherwise return the typed body. `T` is inferred from the client call's data type, so
// call sites collapse to `return unwrap(apiClient.GET("/api/..."))`.
export async function unwrap<T>(
  call: Promise<{ data?: T; error?: unknown; response: Response }>,
): Promise<T> {
  const { data, error, response } = await call
  if (error !== undefined || !response.ok) {
    throw new ApiError(response.status, error)
  }
  return data as T
}
